import { NzConfig } from 'ng-zorro-antd/core/config';

/**
 * App-wide ng-zorro defaults. Notification toasts sit top-right and stack at
 * most 3 deep; `message` is left at ng-zorro's top-centre defaults.
 */
export const NZ_GLOBAL_CONFIG: NzConfig = {
  notification: { nzPlacement: 'topRight', nzMaxStack: 3 },
};
